// DUMMY DATA

import { Button, Col, Form, Input, Row, Space, theme, Typography } from "antd";
import { useEffect, useState } from "react";
import { SearchQuery } from "../code/search-query/search-query";
import {
  departmentsViewColumns,
  mapDepartmentsViewQuery,
} from "./CompanyDepartmentsView.default";
import { DataRequest } from "../controls/Data.default";
import { getCompanyDepartments } from "../repository/data.repository";
import Data from "../controls/Data";

export interface CompanyDepartmentsViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
}

function CompanyDepartmentsView(props: CompanyDepartmentsViewProps) {
  const { token } = theme.useToken();
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);

  const [loading, setLoading] = useState(false);
  const [context, setContext] = useState<{
    readonly searchQuery: SearchQuery;
  }>({
    searchQuery: {
      conditions: [],
    },
  });
  const [valuesValid, setValuesValid] = useState(false);

  useEffect(() => {
    setValuesValid(!form.getFieldsError().some(({ errors }) => errors.length));
  }, [values]);

  useEffect(() => {
    setContext({ ...context });
  }, [props.trigger]);

  function onLoading(loading: boolean): void {
    setLoading(loading);
  }

  function onSearchData(): void {
    const searchQuery = mapDepartmentsViewQuery(values);
    setContext({
      searchQuery,
    });
  }

  function onClearData(): void {
    setValuesValid(true);
    form.resetFields();
  }

  function onAction(key: string, record: any): void {
    props.onAction?.(key, record);
  }

  const request = ({ context, pageNumber, pageSize, sort }: DataRequest) => {
    const sortBy = (sort || [])[0]?.key ?? null;
    const sortDescending = (sort || [])[0]?.direction === "desc";

    return getCompanyDepartments({
      ...context,
      pageNumber: 0,
      pageSize: 100,
      ...(sortBy
        ? {
            sortBy,
            sortDescending,
          }
        : {}),
    }).then(({ data, totalRecords }) => ({
      data,
      pageNumber,
      pageSize,
      total: totalRecords,
    }));
  };

  return (
    <Row className="flex flex-auto flex-row flex-nowrap overflow-hidden">
      {/* Form */}
      <Col
        className="mr-4 flex flex-col border border-solid pl-2 pr-2"
        style={{
          borderColor: token.colorBorder,
          borderRadius: token.borderRadius,
        }}
      >
        <Space className="flex flex-row justify-end pb-2 pt-2">
          <Button disabled={!valuesValid || loading} onClick={onClearData}>
            Clear
          </Button>
          <Button
            type="primary"
            loading={loading}
            disabled={!valuesValid}
            onClick={onSearchData}
          >
            Search
          </Button>
        </Space>
        <Form
          className="my-form-item flex max-w-96 flex-col"
          form={form}
          layout={"vertical"}
          autoComplete="off"
          variant={"filled"}
          colon={false}
        >
          <Form.Item
            className="m-0.5 w-80"
            name={"name"}
            label={
              <Typography.Text
                className="text-sm"
                style={{
                  color: token.colorTextDescription,
                }}
              >
                Name
              </Typography.Text>
            }
          >
            <Input />
          </Form.Item>
        </Form>
      </Col>
      {/* Data */}
      <Data
        columns={departmentsViewColumns}
        context={context}
        pageSize={100}
        actions={[
          {
            key: "update",
            label: "Edit",
            handler: onAction,
          },
          {
            key: "delete",
            label: "Delete",
            danger: true,
            handler: onAction,
          },
        ]}
        request={request}
        rowKey={({ uid }) => uid}
        onLoading={onLoading}
      />
    </Row>
  );
}

export default CompanyDepartmentsView;
